import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import CustomDialog from '../../components/common/CustomDialog';
import { getExcelDataForAfterIssuanceUrl, getExcelDataForBeforeIssuanceUrl } from "../../utils/urls";
import { errorToast, successToast } from "../../utils/toasts";
import CustomButton from '../../components/common/CustomButton/CustomButton';
import { MdOutlineSimCardDownload } from "react-icons/md";
import moment from 'moment/moment';
const DownloadIssuanceExcel = ({ selectedCategory, selectedReportType, closeProcess }) => {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [progress, setProgress] = useState(0);
  const [allData, setAllData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Open the confirmation dialog when the Download Excel button is clicked
  const handleDownloadClick = () => {
    setIsConfirmDialogOpen(true);
  };

  // Handle confirmation to proceed with download
  const handleConfirmDownload = () => {
    setIsConfirmDialogOpen(false);
    setIsPopupOpen(true);
    setCurrentStep(1);
    setProgress(0);
    setAllData([]);
    setError(null);
    fetchData();
  };

  // Handle try again after error
  const handleTryAgain = () => {
    setError(null);
    setCurrentStep(1);
    setProgress(0);
    setAllData([]);
    fetchData();
  };

  // Fetch data with pagination using limit and page_number
  const fetchData = async () => {
    setIsLoading(true);
    let fetchedData = [];
    let pageNumber = 1;
    const limit = 50;
    let hasMoreData = true;

    try {
      while (hasMoreData) {
        let params = {
          limit: limit,
          page_number: pageNumber,
        }
        if(selectedCategory) {
          params.category_id = selectedCategory;
        }

        let url = "";
        if (selectedReportType === "Before Issuance of Policy") {
          url = getExcelDataForBeforeIssuanceUrl;
        } else {
          url = getExcelDataForAfterIssuanceUrl;
        }


        const response = await axios.get(url, {
          params: params
        });
        const data = response.data.data || response.data;
        fetchedData = [...fetchedData, ...data];
        console.log("data", data);

        // Update progress (estimate based on fetches)
        setProgress(Math.min((fetchedData.length / (fetchedData.length + 50)) * 100, 90));

        // Check if there's more data to fetch
        if (data.length < limit) {
          hasMoreData = false;
        } else {
          pageNumber += 1;
        }
      }

      setAllData(fetchedData);
      setProgress(100); // Step 1 complete
      setCurrentStep(2); // Move to Step 2
      console.log("fetchedData", fetchedData);

      generateExcel(fetchedData);


    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to fetch data. Please try again.');
      setIsLoading(false);
    }
  };

  // Generate and download Excel
  const generateExcel = async (data) => {
    setProgress(0); // Reset progress for Step 2
    const dateTime = moment().format("DD-MM-YYYY HH:mm");

    try {
      // Simulate progress for Excel generation
      for (let i = 0; i <= 100; i += 20) {
        setProgress(i);
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      const _data = data?.map((item) => ({
        ...item,
        // created_at: new Date(item.created_at).toLocaleDateString("en-GB", {
        //   day: "2-digit",
        //   month: "long",
        //   year: "numeric",
        // })
      }))

      // Create a new workbook and worksheet
      const ws = XLSX.utils.json_to_sheet(_data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Generate Excel file and download
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${selectedReportType} - ${dateTime}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Close the popup after download
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsLoading(false);
        closeProcess?.();
        successToast("Downloaded Excel file successfully");
      }, 500);
    } catch (error) {
      console.error('Error generating Excel:', error);
      setError('Failed to generate Excel file. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 flex flex-col">
      {/* Download Excel Button */}
      {/* <button
        onClick={handleDownloadClick}
        className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
        disabled={isLoading}
      >
        Download Excel
      </button> */}

      <CustomButton
        startIcon={<MdOutlineSimCardDownload />}
        disabled={!Boolean(selectedCategory && selectedReportType)}
        label="Download Issuance Excel"
        onClick={handleDownloadClick}
        variant="blur"
        className="flex items-center justify-center gap-2"
      />
      {/* <CustomButton
                            disabled={!Boolean(selectedCategory && selectedReportType)}
                            style={{
                              border: "1px solid #0184FF",
                              background: "#EAF4FF",
                              color: "#0184FF",
                            }}
                            startIcon={
                              <DownloadCloudIcon
                                style={{ color: "#0184FF", fontSize: "18px" }}
                              />
                            }
                            label="Download Data Excel"
                            onClick={() => {}}
                          /> */}

      {/* Confirmation Dialog */}
      <CustomDialog
        open={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        title="Download Notice"
        titleClassName="text-center text-base font-bold w-full"
        className="rounded-lg p-4"
      >
        <div className="w-[400px] text-center">
          <p className="text-gray-600 text-left border-b pb-4">
            A downloaded excel file is real data from server. Any status changes after the download will be reflected in database.
          </p>
          <div className="flex justify-between gap-3 mt-6">
            <button
              className="py-2 px-4 bg-white border border-gray-300 font-semibold text-base w-[170px] rounded-full"
              onClick={() => setIsConfirmDialogOpen(false)}
            >
              Cancel
            </button>
            <button
              className="py-2 px-4 bg-blue-600 w-[170px] font-semibold text-base text-white rounded-full disabled:opacity-70"
              onClick={handleConfirmDownload}
              disabled={isLoading}
            >
              Continue
            </button>
          </div>
        </div>
      </CustomDialog>


      {/* Progress Popup Modal */}
      {isPopupOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">
                {error
                  ? 'Error Occurred'
                  : currentStep === 1
                    ? 'Fetching Data...'
                    : 'Generating Excel...'}
              </h2>
              <button
                onClick={() => setIsPopupOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Error Message or Progress */}
            {error ? (
              <div>
                <p className="text-red-600 mb-4">{error}</p>
                <button
                  onClick={handleTryAgain}
                  className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600"
                >
                  Try Again
                </button>
              </div>
            ) : (
              <>
                {/* Step Indicators */}
                <div className="flex justify-between mb-4">
                  <div className={`text-sm ${currentStep === 1 ? 'font-bold text-blue-600' : 'text-gray-500'}`}>
                    Step 1: Fetch Data
                  </div>
                  <div className={`text-sm ${currentStep === 2 ? 'font-bold text-blue-600' : 'text-gray-500'}`}>
                    Step 2: Generate Excel
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="w-full bg-gray-200 rounded-full h-4 mb-4">
                  <div
                    className="bg-blue-600 h-4 rounded-full transition-all duration-300"
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <div className="text-center text-sm text-gray-600">
                  {Math.floor(progress)}% Complete
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadIssuanceExcel;